import DataProvider from '@app/model/_common/DataProvider';
import React from 'react';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';


export const PROVIDER_DATA = {
	[DataProvider.BOOKING]: {
		name: 'Booking',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip" data-tooltip-content="Booking"
							 src={'/assets/img/logos/bookingcom-icon.svg'} alt="Booking" />,
		logo: <img className="block h-5 w-auto relative top-0.5"
							 src="/assets/img/logos/bookingcom.svg" alt="Booking"
							 title="Booking" />
	},
	[DataProvider.HOTELS_COM]: {
		name: 'Hotels.com',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="Hotels.com" src={'/assets/img/logos/hotelscom-icon.svg'}
							 alt="Hotels.com" />,
		logo: <img className="block h-5 w-auto relative top-0.5"
							 src="/assets/img/logos/expedia.svg" alt="Expedia"
							 title="Expedia" />
	},
	[DataProvider.AGODA]: {
		name: 'Agoda',
		icon: <img className="block h-6 w-auto" data-tooltip-id="image-tooltip" data-tooltip-content="Agoda"
							 src={'/assets/img/logos/agoda-icon.svg'} alt="Agoda" />,
		logo: undefined

	},
	[DataProvider.EXPEDIA]: {
		name: 'Expedia',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="Expedia" src={'/assets/img/logos/expedia-icon.svg'}
							 alt="Expedia" />,
		logo: <img className="block h-5 w-auto relative top-0.5"
							 src="/assets/img/logos/expedia.svg" alt="Expedia"
							 title="Expedia" />
	},
	[DataProvider.HOLIDAYCHECK]: {
		name: 'HolidayCheck',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="HolidayCheck" src={'/assets/img/logos/holidaycheck-icon.svg'}
							 alt="HolidayCheck" />,
		logo: <img className="block h-5 w-auto relative top-0.5"
							 src="/assets/img/logos/holidaycheck.svg" alt="HolidayCheck"
							 title="HolidayCheck" />
	},
	[DataProvider.GOOGLE]: {
		name: 'Google',
		icon: undefined,
		logo: undefined
	},
	[DataProvider.TRIP_ADVISOR]: {
		name: 'TripAdvisor',
		icon: undefined,
		logo: undefined
	},
	[DataProvider.TRIP_COM]: {
		name: 'TripAdvisor',
		icon: undefined,
		logo: undefined
	},
	[DataProvider.BRAND_COM]: {
		name: 'Brand.com',
		icon: <div
			className="flex items-center rounded-sm bg-gray-100 px-0.5 py-0.5 text-gray-900 ring-1 ring-inset ring-gray-700/20">
			<BuildingOfficeIcon className="block h-4 w-4 text-gray-500" /></div>,
		logo: undefined
	},
	[DataProvider.PRICELINE]: {
		name: 'Priceline',
		icon: undefined,
		logo: undefined
	},
	[DataProvider.WEBHOTELIER]: {
		name: 'Webhotelier',
		icon: undefined,
		logo: undefined
	},
};

export const findProviderData = (provider: DataProvider) => PROVIDER_DATA[provider];